import api from "../api";
import {subscribeToChannel, unsubscribeToChannel} from "../services/pusher";

const state = () => ({
  contactId: null,
  communicationLogs: [],
  showMoreCommsButton: true,
  paginationPage: 1,
  paginationSize: 25,
  contact: {},
  contactContactTypes: [],
  record: {},
  property: {},
  notes: [],
  isDuplicate: false,
});

const getters = {
  contactId(state) {
    return state.contactId;
  },
  communicationLogs(state) {
    return state.communicationLogs;
  },
  contact(state) {
    return state.contact;
  },
  contactTypes(state) {
    return state.contactContactTypes;
  },
  record(state) {
    return state.record;
  },
  property(state) {
    return state.property;
  },
  notes(state) {
    return state.notes;
  },
  isDuplicate(state) {
    return state.isDuplicate
  },
};

const mutations = {
  setup(state, data) {
    state.communicationLogs = data.communicationLogs;
    state.contact = data.contact;
    state.contactContactTypes = data.contactContactTypes;
    state.record = data.primaryRecord;
    state.property = data.property;
    state.notes = data.notes;
    state.isDuplicate = data.is_duplicate

    state.paginationPage++

    if(data.communicationLogs.length < state.paginationSize) {
      state.showMoreCommsButton = false
    }
  },
  addComms(state, data) {
    const allComms = [
      ...state.communicationLogs,
      ...data.communicationLogs
    ];

    state.paginationPage++

    if(data.communicationLogs.length < state.paginationSize) {
      state.showMoreCommsButton = false
    }

    state.communicationLogs = allComms;
  },
  reset(state) {
    state.contactId = null;
    state.communicationLogs =  [];
    state.contact = {};
    state.contactContactTypes = [];
    state.record = {};
    state.property = {};
    state.notes = [];
    state.isDuplicate = false
  },
  setActiveInboxInboundCommItemId(state, contactId) {
    state.contactId = contactId
  }
};

const actions = {
  setup({commit, state}, contactId) {
    // Make sure you can subscribe to more then one at a time
    if (state.contactId !== null && state.contactId !== contactId) {
      unsubscribeToChannel("activeInboxInboundCommItem", state.contactId);
    }

    commit('setActiveInboxInboundCommItemId', contactId);
    subscribeToChannel("activeInboxInboundCommItem", contactId);

    return api.clientStore.initActiveInboxInboundCommItem(contactId).then((response) => {
      commit('setup', response.data);
    });
  },
  getCommLogs({commit, state}, contactId) {
    return api.clientStore.getActiveInboxInboundCommItemCommLogs(contactId, state.paginationPage, state.paginationSize).then((response) => {
      commit('addComms', response.data);
    });
  },
  tearDown({commit, state}) {
    if (state.contactId !== null) {
      unsubscribeToChannel("activeInboxInboundCommItem", state.contactId);
    }

    commit('reset');
  },
};

const ActiveInboxInboundCommItemStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default ActiveInboxInboundCommItemStore;
